export default {
  computed: {
    $user() {
      try {
        return this.$store.getters['members/me'];
      } catch (e) {
        return false;
      }
    },
  },
};
